import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { Link } from "@StarberryUtils";
import Lightbox from 'react-image-lightbox';
import { isEmpty } from "lodash";
import 'react-image-lightbox/style.css';

const FloorPlanModalDetailsNewHomes = (props) => {
    const [show, setShow] = useState(false);

    var lightImages2 = []
    
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    } 
    
    let srcImgUrl = (props.floorplanimg).split("amazonaws.com/");
    srcImgUrl = srcImgUrl[1]
    srcImgUrl = srcImgUrl.replace("x.prod","i.prod")
    srcImgUrl = srcImgUrl.replace("x.dev","i.dev")
    let parseresizedata = JSON.parse(props.processedImagesFloorplan)
    let imgformat = 'webp'
    let imgsize = '1600x'
    let fullimgpath = props.floorplanimg
    if (!isEmpty(parseresizedata[srcImgUrl])) {
        if (!isEmpty(parseresizedata[srcImgUrl][imgformat])) {
            if (!isEmpty(parseresizedata[srcImgUrl][imgformat][imgsize])) {
                fullimgpath = parseresizedata[srcImgUrl][imgformat][imgsize]
            }
        }
    }

    lightImages2.push(fullimgpath)

    return (
        <>
            <a href="javascript:void(0)" onClick={(e) => openLighboxMobile(e,0)} className="list-inline-item">
                Siteplan
            </a>


            {isOpen && lightImages2.length != 0 && (
                <Lightbox
                    wrapperClassName="light-box-image-zoom"
                    mainSrc={lightImages2[photoIndex]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                    setPhotoIndex((photoIndex + lightImages2.length - 1) % lightImages2.length)
                    }
                    onMoveNextRequest={() =>
                    setPhotoIndex((photoIndex + 1) % lightImages2.length)
                    }
                />
            )}
        </>
    );
}

export default FloorPlanModalDetailsNewHomes;